<template>
  <div>
    <top-title name="会员等级权益" style="margin: 20px 20px; min-width: 980px"></top-title>

    <div class="integralEden">
      <div class="content">
        <div class="hint tipBg">
          <img src="@/assets/images/new_icon_reminder.png" style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 16px 4px 0 3px;
          " />
          会员等级权益：主要应用于【会员升级礼】的会员权益展示。
        </div>

        <!-- 搜索表单 -->
        <div class="search-section">
          <el-form :model="recordForm" :inline="true" class="search-form">
            <el-form-item label="权益名称">
              <el-input v-model="recordForm.name" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker v-model="createTimeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleCreateTimeChange">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="最后修改时间">
              <el-date-picker v-model="updateTimeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleUpdateTimeChange">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">
                <i class="el-icon-search" style="margin-right: 4px;"></i>
                查询
              </el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="table-section">
          <div class="table-top-btns">
            <el-button type="primary" @click="onCreateBenefit(null, 'add')">新增权益</el-button>
          </div>

          <el-table :data="tableData" v-loading="tableLoading" :header-cell-style="{ background: '#FAFAFA' }"
            :cell-style="{ 'text-align': 'left' }" style="width: 100%; margin: 20px auto 40px">
            <el-table-column label="权益图标" min-width="150">
              <template slot-scope="scope">
                <img class="benefit-icon" :src="scope.row.benefitEnableIconUrl" />
              </template>
            </el-table-column>
            <el-table-column label="权益名称" prop="name" min-width="150">
              <template slot-scope="scope">
                {{ scope.row.name || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="跳转链接" prop="jumpInfo" min-width="150">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.jumpInfo || '-'" placement="top"
                  :disabled="!scope.row.jumpInfo || scope.row.jumpInfo.length < 30">
                  <div class="ellipsis-text">{{ scope.row.jumpInfo || "-" }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.createTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="最后修改时间" prop="updateTime" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.updateTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100">
              <template slot-scope="scope">
                <div class="editList">
                  <span class="buttonText" @click="onCreateBenefit(scope.row, 'edit')">编辑</span>
                  <span class="buttonText" @click="onDelete(scope.row)">删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageInfo.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <AddBenefit v-model="isShowAddOrEdit" :controlType="controlType" :rowData="rowData" @update="getTableList" />
  </div>
</template>

<script>
import AddBenefit from "@/views/integralCenter/components/AddBenefit.vue";
import { getMemberBenefitInfo, deleteMemberBenefitInfo } from "@/api/paradiseAndTaskCommonController.js";
import topTitle from "../../components/top-title";

/**
 * 会员等级权益配置
 */
export default {
  components: {
    AddBenefit,
    topTitle
  },
  name: "LevelBenefitManage",
  data() {
    return {
      recordForm: {
        name: "",
        createStartTime: "",
        createEndTime: "",
        updateStartTime: "",
        updateEndTime: "",
      },
      createTimeRange: [],
      updateTimeRange: [],
      tableData: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      tableLoading: false,
      isShowAddOrEdit: false,
      controlType: "add",
      rowData: {},
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    // 处理创建时间变化
    handleCreateTimeChange(val) {
      if (val) {
        this.recordForm.createStartTime = val[0];
        this.recordForm.createEndTime = val[1];
      } else {
        this.recordForm.createStartTime = '';
        this.recordForm.createEndTime = '';
      }
    },

    // 处理修改时间变化
    handleUpdateTimeChange(val) {
      if (val) {
        this.recordForm.updateStartTime = val[0];
        this.recordForm.updateEndTime = val[1];
      } else {
        this.recordForm.updateStartTime = '';
        this.recordForm.updateEndTime = '';
      }
    },

    // 搜索
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getTableList();
    },

    // 重置表单
    resetForm() {
      this.recordForm = {
        name: "",
        createStartTime: "",
        createEndTime: "",
        updateStartTime: "",
        updateEndTime: "",
      };
      this.createTimeRange = [];
      this.updateTimeRange = [];
      this.pageInfo.pageNum = 1;
      this.getTableList();
    },

    // 处理页码变化
    handleCurrentChange(currentPage) {
      this.pageInfo.pageNum = currentPage;
      this.getTableList();
    },

    // 处理每页显示条数变化
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getTableList();
    },

    async getTableList() {
      this.tableLoading = true;
      let params = {
        ...this.recordForm,
        current: this.pageInfo.pageNum,
        size: this.pageInfo.pageSize,
      };
      try {
        const res = await getMemberBenefitInfo(params);
        console.log("--- res:---", res);
        this.tableLoading = false;
        if (res.code == 200 || res.code === 1) {
          let list = res.data.records || [];
          this.tableData = list;
          this.total = Number(res.data.total);
        }
      } catch (err) {
        console.log("--- err:---", err)
        this.tableLoading = false;
      }
    },
    //添加、编辑
    onCreateBenefit(row, type) {
      this.isShowAddOrEdit = true;
      this.controlType = type;
      if (type == "edit") {
        this.rowData = { ...row };
      } else {
        this.rowData = {};
      }
    },
    // 删除权益
    async onDelete(row) {
      try {
        await this.$confirm('确认删除该权益?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        const res = await deleteMemberBenefitInfo(row.id)
        if (res.code == 200 || res.code === 1) {
          this.$message.success('删除成功')
          this.getTableList()
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        // 用户取消删除或发生错误
        if (err !== 'cancel') {
          console.error(err);
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  margin-bottom: 50px;

  .content {
    box-sizing: border-box;
    min-height: 220px;
    padding: 30px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;

    .hint {
      line-height: 45px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 0 0 15px;
      background-color: #fffaee;
    }

    .search-section {
      margin-top: 20px;

      .search-form {
        padding: 15px 0;
      }
    }


    .table-section {
      margin-top: 20px;

      .table-top-btns {
        margin: 15px 0;
      }
    }
  }
}

.benefit-icon {
  width: 70px;
  height: 70px;
}

.editList {
  .el-button {
    margin-left: 0;
    margin-right: 10px;
    color: #3159ff;
  }
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  display: inline-block;
}

.buttonText {
  color: #7b61ff;
  cursor: pointer;
  font-size: 14px;
  margin: 0 4px;
  white-space: nowrap;
}
</style>